import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomFormSelect } from "../../Utils/UI/Text";
import { getRepositorySdgsSelector } from "../Infrastructure/RepositorySdgs.reducer";
import { getRepositorySdgs } from "../Application/RepositorySdgs.business";

const SdgSelector = () => {
  const sdgs = useSelector(getRepositorySdgsSelector);

  useEffect(() => {
    if (!sdgs || sdgs.length === 0) {
      getRepositorySdgs();
    }
  }, [sdgs]);

  const options = sdgs.map(({ code, title }) => ({
    value: Number(code),
    label: `${code} - ${title}`,
  }));

  return (
    <CustomFormSelect
      name="sdgCode"
      placeholder="Seleccione un SDG"
      tooltipText="Seleccione uno de los 17 ODS"
      rules={[{ required: true, message: "Debe seleccionar un SDG" }]}
      options={options}
    />
  );
};

export default SdgSelector;
